import { PreisartTableCell } from './PreisartTableCell';
import { PreisartListEntry } from './PreisartListEntry';

const PreisartEntry = {
    List: PreisartListEntry,
    Cell: PreisartTableCell,
};

export { PreisartEntry };
